module.exports = __webpack_public_path__ + "static/img/jt.8713f05d.png";